import { cn } from '../../lib/cn'
import { Text } from './Text'

type DividerProps = {
  label?: string
  className?: string
}

export function Divider({ label = 'or', className }: DividerProps) {
  return (
    <div className={cn('relative flex items-center py-2', className)}>
      <div className="flex-1 border-t border-foreground/15" />
      <Text variant="caption" className="px-4 uppercase tracking-wide">
        {label}
      </Text>
      <div className="flex-1 border-t border-foreground/15" />
    </div>
  )
}
